<ng-container *transloco="let t; read: 'user'">
  @if (data) {
    <div class="w-max">
      <div class="flex justify-between border-b">
        <h1 class="text-[25px] font-bold">{{ t('addNewChild.droppedChild.title') }}</h1>
        <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
      </div>
      <div mat-dialog-content>
        <drdp-add-edit-table
          [dataSource]="dataSource"
          [tableData]="tableData"
          [columns]="tableColumns"
          (toggleSwitchActionItem)="handleSelectedChild($event)">
        </drdp-add-edit-table>
      </div>
      <div class="flex flex-row justify-end pt-5">
        <drdp-btn mat-button (click)="submitSelectedChild()">{{ t('addNewChild.droppedChild.submit') }}</drdp-btn>
      </div>
    </div>
  }
</ng-container>
